import { useState } from "react"
import { SystemSS } from "../../../components/SystemSS"
import { FullScreenModal } from "../../../utility/FullScreenModal"

export const FacilitiesSalvage = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
        console.log('clickd')
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <>
            <section className=''>
                <div className='flex justify-center '>
                    <img
                        className=''
                        alt='confine'
                        src={`${process.env.PUBLIC_URL}/images/system/system-salvage.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                    <span className='text-pborange'>Automatically obtain treasure</span> hidden in a given nautical region by dispatching Salvage groups. The time needed to complete, and the items received, will change depending on the location and the approach taken by the dispatched Salvage crew.
                    </p>{' '}<br/>
                    <p className="mt-4">
                        Your crew will search for items automatically as time passes, no matter whether you clear a stage or progress the story, so be sure to send those groups out! What a convenient service!
                    </p>
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'salvage',
                                index: 1,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                        description='The items found change depending on the Angler’s level! The amount of time needed to find items will decrease as you power up the Salvage group with BOR (currency).'
                    />{' '}
                </div>
            </section>{' '}
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={1}
            />
        </>
    )
}
